import { Col, Form, Row } from "react-bootstrap";
import { HeaderRegister } from "../../../components/HeaderRegister";
import { HolidayService } from "../../../services/holiday.service";
import { useEffect, useRef, useState } from "react";
import { ToastService } from "../../../services/toast.service";
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from "react-router-dom";
import { Formik, FormikProps } from "formik";
import * as yup from 'yup';
import { HolidayModel } from "../../../models/holiday.model";
import storageService from "../../../services/storage.service";
import { AddressStateModel } from "../../../models/addressState.model";
import LocaleService from "../../../services/locale.service";
import { AddressCountryModel } from "../../../models/addressCountry.model";
import _ from 'lodash';
import DatePicker from "react-datepicker";
import moment from "moment";


export const HolidayRegister = () => {
  const { id } = useParams<{id?: string}>();
  const [initialValues, setInitialValues] = useState<HolidayModel>({
    id: 0,
    addressCountryId: null,
    holidayName: "",
    holidaytype: null,
    addressStateId: null,
    holidayDate: null,
    isActive: null,
    addressCountry: '',
    addressState: ''
  });
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const formRef = useRef<FormikProps<HolidayModel>>(null);
  const history = useHistory();
  
  const [isActive, setIsActive] = useState(null);
  const [countries, setCountries] = useState<AddressCountryModel[]>();
  const [states, setStates] = useState<AddressStateModel[]>();
  const idiom = storageService.getIdiom();
  const [enablesState, setEnablesState] = useState(null);

  const [addressCountryId, setAddressCountryId] = useState(null);
  let defaultaddressCountryId =  null;
  const [defaultAddressCountryId, setDefaultAddressCountryId] = useState(null);

  useEffect(() => {
  }, [defaultAddressCountryId]);

  const initialize = async () => {
    if (Number(id)) {
      const response: any = await HolidayService.getById(id);
      LocaleService.getAllStatesbyLocale().then(async (response: any) => {
        if (response.success) {
          let StatesList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'states' });
          setStates(StatesList[0].data);
        } else {
          setStates([]);
        }
      });

      setIsActive(response.result.isActive);
      setEnablesState(!response.result.addressStateId);

      if (response.success) {
        setInitialValues(response.result);
      }
    }
    else
    {
      LocaleService.getAllStatesbyLocale().then(async (response: any) => {
        if (response.success) {
          let StatesList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'states' });
          setStates(StatesList[0].data);
        } else {
          setStates([]);
        }
      });

    }

    await LocaleService.getAllCountries().then(async (response: any) => {
      if (response.success) {
        let CountriesList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'countries' });
        const countries = CountriesList[0]?.data || [];
        setCountries(countries);
        if (countries.length > 0) {

          setAddressCountryId(countries[0].id_address_country);
          setDefaultAddressCountryId(countries[0].id_address_country)
          defaultaddressCountryId = countries[0].id_address_country;

        }

      } else {
        setCountries([]);
      }
    });
  };

  useEffect(() => {
    initialize();
  }, []);

  const schema = yup.object().shape({
    holidayName: yup.string().required(t('REQUIRED')).max(100, t('HOLIDAY.FULLNAME_MAX_LENGTH')),
    holidayDate: yup.string().nullable().required(t('REQUIRED')), 
    addressCountryId: yup.string().nullable().required(t('REQUIRED')).notOneOf([""], t('REQUIRED')),
    holidaytype: yup.string().nullable().when('id', {
      is: (id: number) => id === 0, // Se o ID for 0 (ou seja, em caso de criação), valida o campo
      then: yup.string().nullable().required(t('REQUIRED')),
      otherwise: yup.string().nullable() // Se for um update (ID > 0), ignora a validação
    }),
    isActive: yup.string().nullable().required(t('REQUIRED')), 
    addressStateId: yup.string().nullable().when('holidaytype', (holidaytype, schema) => {
      return holidaytype == 2
        ? schema.required(t('REQUIRED')).notOneOf([""], t('REQUIRED'))
        : schema.nullable();
    }),
  });

  const submitFormik = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  
  const user = storageService.getUser();
  
  const ListHolidayType = [
    { value: 1, label: t("HOLIDAY.NATIONAL")},
    { value: 2, label: t("HOLIDAY.STATE_TYPE")}
  ];

  const saveHoliday = (holiday: HolidayModel) => {
    setLoading(true);
    if (holiday.id > 0) {
      HolidayService.update(holiday).then((response: any) => {
        if (response.success) {
          ToastService.success(t('HOLIDAY.UPDATED'));
          history.push('/Holiday');
        }
      }).finally(() => {
        setLoading(false);
      });
    } else {
      HolidayService.insert(holiday).then((response: any) => {
        if (response.success) {
          ToastService.success(t('HOLIDAY.INSERTED'));
          history.push('/Holiday');
        }
      }).finally(() => {
        setLoading(false);
      });
    }
  };

  const [selectedStateId, setSelectedStateId] = useState<string | null>(null);
 
  return (
    <>
      <HeaderRegister 
        title={`${t('HOLIDAY.TITLE')} | ${window.location.hash.includes("add") ? t("REGISTRATION") : t("EDITION")}`} 
        path={"/Holiday"} 
        submitForm={submitFormik} 
        isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
      />

      <Formik
        enableReinitialize={true}
        innerRef={formRef}

        initialValues={{
          ...initialValues,
          addressCountryId: defaultAddressCountryId || initialValues.addressCountryId,
        }}      
        validationSchema={schema}
        onSubmit={(values, actions) => {
          saveHoliday(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <Col sm={12} md={3} lg={2} className="mb-4">
                <Form.Group>
                <Form.Floating>
                  <Form.Control
                    name="addressCountryId"
                    id="addressCountryId"
                    type="hidden"
                    onChange={handleChange} 
                    onBlur={handleBlur}
                    disabled={isLoading}
                    isInvalid={touched.addressCountryId && !!errors.addressCountryId}
                    value={values.addressCountryId || defaultaddressCountryId} 
                    maxLength={100}
                />
                <Form.Select
                  id="addressCountryId"
                  name="addressCountryId"
                  isInvalid={touched.addressCountryId && !!errors.addressCountryId}
                  disabled={true}
                  onChange={(event) => {
                    handleChange(event); 
                    setStates([]);
                    const countryId = event.target.value;
                    if (countryId) {
                      LocaleService.getAllStates(countryId).then(async (response: any) => {
                        if (response.success) {
                          const statesList = response.result.datasets.filter((dataset) => dataset.dataset === 'states');
                          setStates(statesList[0].data);  
                        } else {
                          setStates([]); 
                        }
                      });
                    }
                  }}
                  value={values.addressCountryId || (countries && countries.length ? countries[0].id_address_country : defaultaddressCountryId)}
                  aria-label={t("EQUIPMENT.COUNTRY")}
                >
                  <option value="">{t("EQUIPMENT.COUNTRY")}</option>
                  {countries &&
                    _.map(countries, (l: AddressCountryModel) => (
                      <option key={l.id_address_country} value={l.id_address_country}>
                        {l.abbreviation}
                      </option>
                    ))}
                </Form.Select>

                <Form.Control.Feedback type="invalid">
                  {errors.addressCountryId}
                </Form.Control.Feedback>

                <label htmlFor="addressCountryId">{t("EQUIPMENT.COUNTRY")}</label>
                </Form.Floating>

                </Form.Group>
              </Col>

              <Col sm={12} md={6} lg={3} className="mb-4">
                <Form.Group>
                  <Form.Floating>
                    <Form.Control
                      name="holidayName"
                      id="holidayName"
                      type="text"
                      placeholder={t('HOLIDAY.FULLNAME')}
                      value={values.holidayName}
                      onChange={handleChange} 
                      onBlur={handleBlur}
                      disabled={isLoading}
                      isInvalid={touched.holidayName && !!errors.holidayName} 
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.holidayName}
                    </Form.Control.Feedback>
                    <Form.Label>{t('HOLIDAY.FULLNAME')}</Form.Label>
                  </Form.Floating>
                </Form.Group>
              </Col>

              <Col sm={12} md={3} lg={2} className="mb-4">
                <Form.Group>
                  <Form.Floating>
                    <Form.Control
                      name='holidaytype'
                      id='holidaytype'
                      type='hidden'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={isLoading}
                      isInvalid={touched.holidaytype && !!errors.holidaytype}
                      value={
                        values.id > 0
                          ? values.addressStateId
                            ? "2"
                            : "1"
                          : null
                      } 
                      maxLength={100}
                    />
                    <Form.Select
                      id='holidaytype'
                      name='holidaytype'
                      isInvalid={touched.holidaytype && !!errors.holidaytype}
                      onChange={(event) => {
                        handleChange(event);
                        const selectedValue = event.target.value;
                        setEnablesState(selectedValue == "1");
                        if (selectedValue == "1")
                        {
                          handleChange({ target: { name: 'addressStateId', value: null } });
                        }
                      }}
                      value={
                        values.holidaytype ??
                        (values.id > 0
                          ? values.addressStateId
                            ? "2"
                            : "1"
                          : "")
                      }                      
                      aria-label={t("HOLIDAY.HOLIDAY_TYPE")}>
                      <option value=''>
                        {t("HOLIDAY.HOLIDAY_TYPE")}
                      </option>
                      {_.map(ListHolidayType, (l) => { 
                        return (
                          <option key={l.value} value={l.value}>
                            {l.label} 
                          </option>
                        );
                      })}                            
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.holidaytype}
                    </Form.Control.Feedback>
                    <label htmlFor="holidaytype">{t("HOLIDAY.HOLIDAY_TYPE")}</label>
                  </Form.Floating>
                </Form.Group>
              </Col>  

              <Col sm={12} md={3} lg={2} className="mb-4">
                <Form.Group>
                  <Form.Floating>
                    <Form.Control
                      name='addressStateId'
                      id='addressStateId'
                      type='hidden'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={isLoading}
                      isInvalid={touched.addressStateId && !!errors.addressStateId}
                      value={values.addressStateId}
                      maxLength={100}
                    />
                    <Form.Select
                      id='addressStateId'
                      name='addressStateId'
                      isInvalid={touched.addressStateId && !!errors.addressStateId}
                      onChange={(event) => {
                        handleChange(event);
                        setSelectedStateId(event.target.value); // Atualiza o estado local
                      }}
                      disabled={isLoading || enablesState}
                      value={enablesState ? "" : values.addressStateId}
                      aria-label={t("BRANCH.STATE")}>
                      <option value=''>
                        {t("BRANCH.STATE")}
                      </option>
                      {_.map(states, (l: AddressStateModel) => {
                        return (
                          <option key={l.id_address_state} value={l.id_address_state}>
                            {l.name}
                          </option>
                        );
                      })}                            
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.addressStateId}
                    </Form.Control.Feedback>
                    <label htmlFor="addressStateId">{t("BRANCH.STATE")}</label>
                  </Form.Floating>
                </Form.Group>
              </Col>                                 
            </Row>
            <Row>
              <Col sm={12} md={4} lg={2}>
                <Form.Group>
                  <Form.Floating>
                    <Form.Control
                      name="holidayDate"
                      id="holidayDate"
                      type="hidden"
                      value={
                        values.holidayDate
                          ? moment(values.holidayDate).format("YYYY-MM-DD")
                        : ''
                      }
                      isInvalid={touched.holidayDate && !!errors.holidayDate}
                    />
                    <DatePicker
                      name="holidayDate"
                      id="holidayDate"
                      selected={
                        values.holidayDate
                          ? moment(values.holidayDate).toDate()
                          : null
                      }
                      onChange={(date) => {
                        if (date) {
                          const formattedDate = moment(date).format("YYYY-MM-DD");
                          handleChange({ target: { name: "holidayDate", value: formattedDate } });
                        } else {
                          handleChange({ target: { name: "holidayDate", value: '' } });
                        }
                      }}
                      minDate={new Date(new Date().getFullYear(), 0, 1)}
                      className="form-control"
                      dateFormat="dd/MM/yyyy"
                      isClearable={true}
                      locale={idiom.replaceAll('-', '').trim()}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.holidayDate}
                    </Form.Control.Feedback>
                    <label htmlFor="holidayDate">{t("HOLIDAY.DATE")}</label>
                  </Form.Floating>
                </Form.Group>
              </Col>
              <Col sm={12} md={4} lg={2}>
                <Form.Group>
                  <Form.Floating>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Form.Label style={{ marginRight: '10px' }}>Status</Form.Label>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <Form.Check
                          type="radio"
                          id="status-true"
                          label={t('HOLIDAY.ACTIVE')}
                          name="isActive"
                          value="true"
                          checked={isActive === true} // Verifica se o estado é true
                          onChange={(event) => {
                            setIsActive(true); // Atualiza o estado local
                            handleChange({ target: { name: 'isActive', value: true } }); // Atualiza os valores do formulário
                          }}
                          inline
                        />
                        <Form.Check
                          type="radio"
                          id="status-false"
                          label={t('HOLIDAY.INACTIVE')}
                          name="isActive"
                          value="false"
                          checked={isActive === false} // Verifica se o estado é false
                          onChange={(event) => {
                            setIsActive(false); // Atualiza o estado local
                            handleChange({ target: { name: 'isActive', value: false } }); // Atualiza os valores do formulário
                          }}
                          inline
                        />
                      </div>
                    </div>
                    {touched.isActive && errors.isActive && (
                      <Form.Control.Feedback type="invalid" style={{ display: 'block', marginTop: '5px' }}>
                        {errors.isActive}
                      </Form.Control.Feedback>
                    )}
                  </Form.Floating>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
